module.exports = __webpack_public_path__ + "images/ch4_fig1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ch4/ch4_fig1.jpg
// module id = 182
// module chunks = 0